import { CSSProperties } from 'react'

import { AvailableConnection } from 'app/connections/types'

import {
  AmazonIcon,
  CriteoIcon,
  DV360Icon,
  FacebookIcon,
  GoogleAdsenseIcon,
  GoogleAnalyticsIcon,
  GoogleBigQueryIcon,
  InnkeeprIcon,
  ShopifyIcon,
  TikTokIcon,
  WooCommerceIcon,
} from '../icons'

interface ConnectionIconProps {
  connection: Pick<AvailableConnection, 'name'>
  style?: CSSProperties
}
const ConnectionIcon = ({ connection: connection, style }: ConnectionIconProps) => {
  switch (connection.name) {
    case 'adtribute':
      return <></>
    case 'amazon':
      return <AmazonIcon style={style} />
    case 'criteo':
      return <CriteoIcon style={style} />
    case 'dv360':
      return <DV360Icon style={style} />
    case 'facebook':
      return <FacebookIcon style={style} />
    case 'googleAdwords':
      return <GoogleAdsenseIcon style={style} />
    case 'googleAnalytics':
      return <GoogleAnalyticsIcon style={style} />
    case 'googleBigquery':
      return <GoogleBigQueryIcon style={style} />
    case 'innkeepr':
      return <InnkeeprIcon style={style} />
    case 'shopify':
      return <ShopifyIcon style={style} />
    case 'tiktok':
      return <TikTokIcon style={style} />
    case 'woocommerce':
      return <WooCommerceIcon style={style} />
  }
}

export default ConnectionIcon
